import React from 'react';

import { colors } from 'src/styles/colors';
import { mixpanelObject } from 'src/utils/analytics';
import { globalUrlHelper } from 'src/utils/common';

import * as customStyled from './styles';
import { ctaEvent } from '../../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CTA
} from '../../../../../utils/analytics/mixpanel/mixpanelConstants';

export interface ValueObject {
  text: string;
  link?: string;
  textColor?: string;
  mixpanelElementName?: string;
}

interface SupportedItemsProps {
  title: string;
  values: ValueObject[];
}

const metaDataMixpanelEvents = (mixpanelElementName: string) => {
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, mixpanelElementName);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  ctaEvent();
};

const navigate =
  (link: string, mixpanelElementName?: string) =>
  (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.href = link;
    if (mixpanelElementName) {
      metaDataMixpanelEvents(mixpanelElementName);
    }
  };

const SupportedItems: React.FC<SupportedItemsProps> = ({ title, values }) => {
  const renderValues = () => {
    return values?.map(
      (
        { text, link, textColor = colors.white, mixpanelElementName },
        index
      ) => {
        const isLastItem = index === values.length - 1;
        if (link) {
          return (
            <a
              key={index}
              href={globalUrlHelper(link)}
              aria-label={text}
              onClick={navigate(globalUrlHelper(link), mixpanelElementName)}
              css={customStyled.valueStyle(colors.PurpleLight, link)}>
              {text}
              {!isLastItem ? ',' : ''}{' '}
            </a>
          );
        }
        return (
          <p key={index} css={customStyled.valueStyle(textColor as string)}>
            {text}
            {!isLastItem ? ',' : ''}
          </p>
        );
      }
    );
  };

  return (
    <div css={customStyled.wrapper}>
      <div css={customStyled.keyStyle}>{title} : </div>
      <div css={customStyled.wrapper}>{renderValues()}</div>
    </div>
  );
};

export default SupportedItems;
